import { render } from "./imageDisplay.vue?vue&type=template&id=5e5f1ccd&scoped=true"
import script from "./imageDisplay.vue?vue&type=script&lang=js"
export * from "./imageDisplay.vue?vue&type=script&lang=js"

import "./imageDisplay.vue?vue&type=style&index=0&id=5e5f1ccd&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5f1ccd"]])

export default __exports__